import { Component, OnInit, Input } from "@angular/core";
import { ClassroomAttendanceService } from "./../../classroomAttendance.service";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { AddRedeemPointService } from "./redeemPoints.service";
declare var moment: any;

@Component({
	selector: "caass-classroom-classroomAttendance-Point-RedeemPoints",
	templateUrl: "./RedeemPoints.component.html",
	providers: [AddRedeemPointService],
})
export class ClassroomAttendancePointRedeemPointsComponent {
	@Input() studentid: any;
	@Input() balancePoint: any;
	@Input() personid: any;
	@Input() schoolID: any;
	pointsItemList: any = [];
	erroMessage = "";
	constructor(private classroomService: ClassroomAttendanceService, private redeemPointService: AddRedeemPointService) {}
	points: any = {
		PointsItemID: 0,
		PointsItemValue: 0,
		PointsTransactionTypeID: 1,
	};
	ngOnInit() {
		this.points.SchoolID = this.schoolID;
		this.points.PersonID = this.personid;
		this.PointsItemGetList();
	}
	cancelClick() {
		this.classroomService.cancelEdit();
	}

	private PointsItemGetList() {
		var result = this.redeemPointService.PointsItemGetList(this.schoolID);

		result.subscribe(
			(response: any) => {
				this.pointsItemList = response;

				if (this.pointsItemList.length > 1) {
					this.pointsItemList.unshift({
						PointsItemID: 0,
						PointsItemDesc: "Choose Point to be awarded",
						PointsItemValue: "",
					});
				}
			},

			(error) => {}
		);
	}

	onPointsItemChange(newPointsItemID) {
		this.points.PointsItemID = newPointsItemID;
		const result = this.pointsItemList.filter((index) => index.PointsItemID == newPointsItemID);
		this.points.PointsItemValue = result[0].PointsItemValue;
		this.points.PointsTransactionTypeID = 2;
	}
	saving = false;
	submitClick() {
		if (!this.points.PointsItemValue) {
			this.erroMessage = "Select the point";
			return;
		}
		this.balancePoint = this.balancePoint + this.points.PointsItemValue;

		var result = this.redeemPointService.TransactionInsert(this.points);

		result.subscribe(
			(response: any) => {
				this.cancelClick();
				this.classroomService.LoadData();
			},
			(error) => {
				this.erroMessage = "Error Occured";
				this.saving = false;
			}
		);
	}
}
